import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LessonNotesComponent } from './components/lesson-notes/lesson-notes.component';
import { LessonAttachmentComponent } from './components/lesson-attachment/lesson-attachment.component';
import { LessonNoteUnitComponent } from './components/lesson-unit/lesson-unit.component';
import { TeacherNoteComponent } from './components/teacher-note/teacher-note.component';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { BackButtonModule } from '../../common/back-button/back-button.module';
import { VideoLessonAttachmentComponent } from './components/video-lesson-attachment/video-lesson-attachment.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
@NgModule({
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    BackButtonModule
  ],
  declarations: [
    LessonNotesComponent,
    LessonAttachmentComponent,
    LessonNoteUnitComponent,
    TeacherNoteComponent,
    VideoLessonAttachmentComponent
  ],
  exports: [LessonNotesComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class LessonNotesModule { }
